export interface PeopleAlsoViewedItem {
  articleNumber: string
  title: string
  href: string
}

export function parsePeopleAlsoViewed(htmlContent: string): PeopleAlsoViewedItem[] {
  if (!htmlContent) return []

  const items: PeopleAlsoViewedItem[] = []

  const linkRegex = /<a\s+href="([^"]*\/articles\/[^/]+\/Knowledge\/([^"]+))"[^>]*>([^<]+)<\/a>/g

  let match
  while ((match = linkRegex.exec(htmlContent)) !== null) {
    const [, href, articleNumber, title] = match

    items.push({
      articleNumber: articleNumber.trim(),
      title: title.trim(),
      href: href.trim(),
    })
  }

  return items.slice(0, 2)
}
